import React, { useEffect, useState } from "react";
import { useAppEventGameDetailSelector } from "src/_common/hooks/selectors/eventSelector";

const UserAnswers = ({ editUserAnswer }: any) => {
  const [answerDetails, setAnswerDetails] = useState<any>();
  const [earnedPoints, setEarnedPoints] = useState<any>(0);
  const eventGameDetailsSelector = useAppEventGameDetailSelector();
  const [anyAnswerDeclared, setAnyAnswerDeclared] = useState(false);

  useEffect(() => {
    console.log(eventGameDetailsSelector?.events?.user_answers, eventGameDetailsSelector.events.questions_dtls);
    // if (eventGameDetailsSelector?.events?.user_answers?.length) {
    //   const matchedAnswers = eventGameDetailsSelector.events?.user_answers?.map((answer: any) => {
    //     const question = eventGameDetailsSelector?.events?.questions_dtls?.find(
    //       (q: any) => q.id === answer.question_id
    //     );
    //     const ans = question?.answer_cont_dtls?.find((a: any) => a.id === answer.answer_id);
    //     if (ans && question) {
    //       return {
    //         answer: ans,
    //         question,
    //       };
    //     }
    //   });
    //   setAnswerDetails(matchedAnswers);
    //   console.log({ matchedAnswers });
    // }
    if (eventGameDetailsSelector?.events?.questions_dtls?.length) {
      let point = 0;
      let c = 0;
      const matchedAnswers = eventGameDetailsSelector.events?.questions_dtls?.map((question: any) => {
        const ans = eventGameDetailsSelector?.events?.user_answers?.find((a: any) => a.question_id === question.id);
        const answer = question?.answer_cont_dtls?.find((a: any) => a.id === ans?.answer_id);
        console.log({ answer });
        const correct_answer = question?.answer_cont_dtls?.find((a: any) => a.is_winner == 1);
        if (correct_answer) {
          c = c + 1;
        }
        if (answer && correct_answer) {
          point = point + Number(answer?.id === correct_answer?.id ? correct_answer?.point : 0);
        }
        if (answer) {
          return {
            answer,
            question,
            correct_answer,
          };
        } else {
          return {
            answer: { answer_contestant: null, point: 0 },
            question,
            correct_answer,
          };
        }
      });
      setEarnedPoints(point);
      setAnswerDetails(matchedAnswers);
      if (c > 0) {
        setAnyAnswerDeclared(true);
      }
      console.log({ matchedAnswers });
    }
  }, [eventGameDetailsSelector]);

  return (
    <>
      <>
        {eventGameDetailsSelector.events?.questions_dtls?.length ==
          eventGameDetailsSelector.events?.user_answers?.length &&
          eventGameDetailsSelector?.events?.user_tiebreaker_details?.code && (
            <div className="congrats-banner mb-4">
              <img src="/images/game-card.png" />
              <div className="congrats-text">
                <h2>Congratulations!</h2>
                <p>All your quicks are in!</p>
              </div>
            </div>
          )}
        <div className="team-list-block">
          <div className="d-flex gap-3 align-items-center">
            <div className="team-list-icon">
              <img
                src={
                  eventGameDetailsSelector?.events?.event_dtls?.avatar?.id != 0
                    ? eventGameDetailsSelector?.events?.event_dtls?.avatar?.thumb
                    : "/images/no-image.png"
                }
                style={{ width: "100%" }}
                alt={eventGameDetailsSelector?.events?.event_dtls?.title}
              />
            </div>
            <div className="team-list-content flex-grow-1">
              <h4 className="mb-1 text-white">
                {eventGameDetailsSelector?.events?.event_title || eventGameDetailsSelector?.events?.event_dtls?.title}
              </h4>
              {<p>Completed Successfully.</p>}
              <p>
                Earned Points: <strong>{earnedPoints}</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="success-points-list-panel">
          {answerDetails?.length > 0 ? (
            <>
              {answerDetails?.map(
                (item: any, i: any) =>
                  item && (
                    <div className="success-points-list-block" key={i}>
                      <div className="success-points-correct-block">
                        <div className="success-points-list-content">
                          <h6>{item?.answer?.point || 0} Points</h6>
                          <h4>{item?.question?.question}</h4>
                          {item?.question?.question_type == 2 ? (
                            <div className="d-flex align-items-center gap-3">
                              {item?.answer?.answer_contestant && (
                                <div className="avatar">
                                  <img
                                    src={
                                      item?.answer?.contestant_avatar?.id != 0
                                        ? item?.answer?.contestant_avatar?.original
                                        : item?.answer?.contestant_dtls?.avatar?.id != 0
                                        ? item?.answer?.contestant_dtls?.avatar?.original
                                        : "/images/no-image.png"
                                    }
                                    style={{ width: "100%" }}
                                  />
                                </div>
                              )}
                              <h5>{item?.answer?.answer_contestant || "---"}</h5>
                            </div>
                          ) : (
                            <h5>{item?.answer?.answer_contestant || "---"}</h5>
                          )}
                        </div>
                        {/* {item?.question?.winning_declare != 1 && eventGameDetailsSelector?.events?.status != 2 && ( */}
                        {eventGameDetailsSelector?.events?.status == 0 && (
                          <a onClick={() => editUserAnswer(item, i)}>
                            <i className="edit-icon" />
                          </a>
                        )}
                      </div>
                      {item?.correct_answer ? (
                        <>
                          <div
                            className="success-points-list-block"
                            style={{
                              backgroundColor: "#2b3c5e" /* position: 'relative', */,
                              marginTop: 10,
                              marginBottom: 0,
                              display: "flex",
                            }}
                          >
                            <div className="correct-answer">Correct Answer</div>
                            <div className="success-points-list-content">
                              <h6 className="mt-3">{item?.correct_answer?.point} Points</h6>
                              {item?.question?.question_type == 2 ? (
                                <div className="d-flex align-items-center gap-3">
                                  <div className="avatar">
                                    <img
                                      src={
                                        item?.correct_answer?.contestant_avatar?.id != 0
                                          ? item?.correct_answer?.contestant_avatar?.original
                                          : item?.correct_answer?.contestant_dtls?.avatar?.id != 0
                                          ? item?.correct_answer?.contestant_dtls?.avatar?.original
                                          : "/images/no-image.png"
                                      }
                                      style={{ width: "100%" }}
                                    />
                                  </div>
                                  <h5>{item?.correct_answer?.answer_contestant}</h5>
                                </div>
                              ) : (
                                <h5>{item?.correct_answer?.answer_contestant}</h5>
                              )}
                            </div>
                            {/* <div className="completed-tick">
                            <img src="/images/check.svg" />
                          </div> */}
                            {/* <div>Correct Answer</div> */}
                          </div>
                        </>
                      ) : null}
                    </div>
                  )
              )}
              <div className="success-points-list-block d-flex">
                <div className="success-points-list-content">
                  <h4>Tie Breaker</h4>
                  <h5>{eventGameDetailsSelector?.events?.user_tiebreaker_details?.code || "---"}</h5>
                </div>
                {/* {(eventGameDetailsSelector?.events?.winning_declare != 1 &&
                  eventGameDetailsSelector?.events?.status != 2) || */}
                {/* {!anyAnswerDeclared || eventGameDetailsSelector?.events?.status == 0 ? ( */}
                {eventGameDetailsSelector?.events?.status == 0 ? (
                  <a onClick={() => editUserAnswer(null, eventGameDetailsSelector.events.questions_dtls?.length)}>
                    <i className="edit-icon" />
                  </a>
                ) : null}
              </div>
            </>
          ) : null}
        </div>
      </>
    </>
  );
};

export default UserAnswers;
